import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactSelect from "react-select";
import { Input } from "styled";
import { useQuery } from "react-query";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import Modal from "components/Modal";
import { Button } from "styled";
import getFormattedDate, { convertToIndianTimezoneAndGetDate } from "utils/helpers";
import 'chartjs-plugin-datalabels'; // Import the datalabels plugin
import axios from "../apis/axios";
import toast from "react-hot-toast";
import { BiCloudDownload } from "react-icons/bi";
// import { BiSolidCircle } from "react-icons/bi";

const getLocation = (status) => {
    switch (status) {
      case "REUSE":
        return "RSU";
      case "RETREAD":
        return "RTD";
      case "CASING":
        return "CS1";
      case "REPAIR":
        return "CTR";
      case "MISSING":
        return "MIS";
      case "SCRAP":
        return "SRP";
      case "READY_TO_FIT_OUT":
        return "ITM";
      case "FITTED":
        return "OWH";
      default:
        return "---";
    }
  };

const getOneYearAgoDate = () => {
    const today = new Date();
    const oneYearAgo = new Date(today.setFullYear(today.getFullYear() - 1));
    const year = oneYearAgo.getFullYear();
    const month = String(oneYearAgo.getMonth() + 1).padStart(2, '0');
    const day = String(oneYearAgo.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const getOneYearFromDate = (date) => {
    const givenDate = new Date(date);
    const oneYearFromDate = new Date(givenDate.setFullYear(givenDate.getFullYear() + 1));
    return getFormattedDate(oneYearFromDate);
};

const POLL_INTERVAL_MS = 1500;
const PROGRESS_POLL_MAX_AGE_MS = 15 * 60 * 1000;

const BatchWiseReport = () => {

    const pollRef = useRef(null);
    const [downloadProgress, setDownloadProgress] = useState(null);

    const [selectedFleets, setSelectedFleets] = useState([]);
    const [selectedHubs, setSelectedHubs] = useState("all");
    const [downloading, setDownloading] = useState(false);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [contractType, setContractType] = useState("")
    const [selectedSizes, setSelectedSizes] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedCPKMSizes, setSelectedCPKMSizes] = useState([]);
    const [selectedCPKMProducts, setSelectedCPKMProducts] = useState([]);
    const [selectedFleetCodes, setSelectedFleetCodes] = useState(null)
    const [fetch, setFetch] = useState(0)
   
    const [dateFrom, setDateFrom] = useState(getOneYearAgoDate());
    const [dateTo, setDateTo] = useState(getFormattedDate(new Date()));

    const { data: allFleets, isLoading: loadingFleets, refetch } = useQuery(
        [
            "customer-fleet",
        ], () =>
        getAllData("/customer-fleet", {
            limit: 3000,
        })
    );
    const { data: allHubs } = useQuery(
        [
            "customer-hub",
            selectedFleetCodes && selectedFleetCodes
        ], () =>
        getAllData("/customer-hub", {
            ...selectedFleetCodes && { fleetCode: selectedFleetCodes },
            limit: 3000,
        })
    );
    const { data: allConfigurations } = useQuery([`/vehicle-configuration-master`], () =>
        getAllData("/vehicle-configuration-master", {
            limit: 2000,
            page: 1,
        })
    );
    const { data: allProducts } = useQuery([`product-brands`, contractType], () =>
        getAllData("/product/getBrands", {
            limit: 300,
            page: 1,
        }),
        {
            enabled: contractType !== "NON CPKM", // Only fetch data if condition is true
        }
    );

    const { data: allProductMasters } = useQuery([`/product-master`, contractType], () =>
        getAllData("/product-master", {
            limit: 1000,
            page: 1,
        }),
        {
            enabled: contractType !== "CPKM", // Only fetch data if condition is true
        }
    );

    const getData = async () => {
        setIsLoading(true)
        try {
            const dt = await createDocument("/report/batchWiseReport", {
                // ...(selectedFleets !== "all" ? {
                //     fleets: selectedFleets
                // } : { fleets: allFleets?.data.map(data => { return data._id }).join(",") }),
                ...(!selectedFleets?.length || selectedFleets?.includes("all")
                    ? {
                        fleets: getFleetOptions().filter(item => item.value !== "all" && item.value !== "clear")
                            .map((item) => item.value)
                            .join(","),
                    }
                    : selectedFleets.length && {
                        fleets: selectedFleets.map((fleet) => fleet).join(","),
                    }),
                    
                
                // ...(selectedCPKMProducts.length && {
                //     cpkmproducts: selectedCPKMProducts.flatMap((make) => make.meta.ids).join(","),
                // }),

                ...(selectedProducts?.includes('all') ? { cpkmproducts: selectedCPKMProducts.filter(item => item.value !== "all" && item.value !== "clear").flatMap((make) => make.meta.ids).join(",") } : selectedProducts.length && {
                    cpkmproducts: selectedCPKMProducts.flatMap((make) => make.meta.ids).join(",")
                }),

                ...(selectedCPKMSizes.length && {
                    tyreSize: selectedCPKMSizes.map((make) => make).join(","),
                }),

                // ...(selectedProducts.length && {
                //     products: selectedProducts.flatMap(item => item.meta.ids).join(","),
                // }),

                ...(selectedProducts?.includes('all') ? { products: selectedProducts.filter(item => item.value !== "all" && item.value !== "clear").flatMap((make) => make.meta.ids).join(",") } : selectedProducts.length && {
                    products: selectedProducts.flatMap((make) => make.meta.ids).join(",")
                }),

                ...(contractType && { contractType }),
                ...(dateFrom && {
                    from: dateFrom,
                }),
                ...(dateTo && {
                    to: dateTo,
                }),
            })
            if (dt) {
              
                
                setData(dt);
            }// console.log('dt',dt)
        } catch (err) {
        } finally {
            setIsLoading(false)
        }
    }

    const getDownloadData = async () => {
        setDownloading(true)
        try {
            const dt = await createDocument("/report/batchWiseReport", {
                // Fleets logic
                ...(selectedFleets?.includes("all")
                    ? {
                        fleets: getFleetOptions()
                            .filter(item => item.value !== "all" && item.value !== "clear")
                            .map((item) => item.value)
                            .join(","),
                    }
                    : selectedFleets.length && {
                        fleets: selectedFleets.map((fleet) => fleet).join(","),
                    }),
    
                // CPKM Products logic
                ...(selectedCPKMProducts.length && {
                    cpkmproducts: selectedCPKMProducts
                        .flatMap((make) => make.meta.ids)
                        .join(","),
                }),
    
                // Tyre Size logic
                ...(selectedCPKMSizes.length && {
                    tyreSize: selectedCPKMSizes.map((size) => size).join(","),
                }),
    
                // Products logic
                ...(selectedProducts.length && {
                    products: selectedProducts
                        .flatMap(item => item.meta.ids)
                        .join(","),
                }),
    
                // Contract Type
                ...(contractType && { contractType }),
    
                // Date Range (from and to)
                ...(dateFrom && { from: dateFrom }),
                ...(dateTo && { to: dateTo }),
            });
    
            if (dt) {
                const exportData = dt.map((e, i) => {
                    console.log(e.data);
                    
                const parentData = {
                    "S.NO": i + 1,
                    "Batch": e?.batch,
                    "Brand": "-",
                    "Tyre Supplied": e?.totalTyreSupplied ?? 0,
                    "Count ITM Scrap": e?.totalCountITMScrap ?? 0,
                    "Avg ITM Scrap": Math.round(e?.avgITMScrap ?? 0) ?? 0,
                    "Count ITM": e?.totalCountITM ?? 0,
                    "Avg ITM": Math.round(e?.avgITM ?? 0) ?? 0,
                    "Count RTD Scrap": e?.totalCountRTDScrap ?? 0,
                    "Avg RTD Scrap": Math.round(e?.avgRTDScrap ?? 0) ?? 0,
                    "Count RTD1": e?.totalCountRTD1 ?? 0,
                    "Avg RTD1": Math.round(e?.avgRTD1 ?? 0) ?? 0,
                    "Count RTD2": e?.totalCountRTD2 ?? 0,
                    "Avg RTD2": Math.round(e?.avgRTD2 ?? 0) ?? 0,
                    "Count RTD3": Math.round(e?.totalCountRTD3 ?? 0)?? 0,
                    "Avg RTD3": Math.round(e?.avgRTD3 ?? 0) ?? 0,
                    "ITM 85% Proj.":Math.round(e?.totalCountITM85Projection ?? 0) ?? 0,
                    "Avg ITM 85% Proj.": Math.round(e?.avgITM85Projection ?? 0) ?? 0,
                    "RTD 85% Proj.": Math.round(e?.totalCountRTD85Projection ?? 0) ?? 0,
                    "Avg RTD 85% Proj.": Math.round(e?.avgRTD85Projection ?? 0) ?? 0,
                };
    
                // Handle nested data
                const nestedData = e.data.map((child, idx) => {
                    console.log(child)
                    // Handle brand - if it's an array, take first element
                    const brandValue = Array.isArray(child?.brand) ? child?.brand[0] : child?.brand;
                    return {
                        "S.NO":'.',
                        "Batch": child?.batch,
                        "Brand": brandValue || '---',
                        "Tyre Supplied": Math.round(child?.tyreSupplied?.length ?? 0),
                        "Count ITM Scrap": Math.round(child?.countITMScrap?.length ?? 0),
                        "Avg ITM Scrap": Math.round(child?.avgITMScrap ?? 0),
                        "Count ITM": Math.round(child?.countITM?.length ?? 0),
                        "Avg ITM": Math.round(child?.avgITM ?? 0) ?? 0,
                        "Count RTD Scrap": child?.countRTDScrap?.length ?? 0,
                        "Avg RTD Scrap": Math.round(child?.avgRTDScrap ?? 0) ?? 0,
                        "Count RTD1": child?.countRTD1?.length ?? 0,
                        "Avg RTD1": Math.round(child?.avgRTD1 ?? 0) ?? 0,
                        "Count RTD2": Math.round(child?.countRTD2?.length ?? 0) ?? 0,
                        "Avg RTD2": Math.round(child?.avgRTD2 ?? 0) ?? 0,
                        "Count RTD3": child?.countRTD3?.length ?? 0,
                        "Avg RTD3": Math.round(child?.avgRTD3 ?? 0) ?? 0,
                        "ITM 85% Proj.": Math.round(child?.countITM85Projection?.length ?? 0) ?? 0,
                        "Avg ITM 85% Proj.": Math.round(child?.avgITM85Projection ?? 0) ?? 0,
                        "RTD 85% Proj.": Math.round(child?.countRTD85Projection?.length ?? 0) ?? 0,
                        "Avg RTD 85% Proj.": Math.round(child?.avgRTD85Projection ?? 0) ?? 0,
                    };
                });
    
                    return [parentData, ...nestedData];
                });
    
                // Flatten the array of arrays into a single array
                const flattenedExportData = exportData.flat();

                // Export to Excel
                exportExcel(flattenedExportData, "Batch wise report download", false);
            }
        } catch (err) {
            console.error("Error fetching batch wise report data:", err);
        }finally{
            setDownloading(false)
        }
    };

    const pollDownloadProgress = useCallback((requestId, startedAt) => {
        if (pollRef.current) clearInterval(pollRef.current);
        const poll = async () => {
            if (Date.now() - startedAt > PROGRESS_POLL_MAX_AGE_MS) {
                if (pollRef.current) clearInterval(pollRef.current);
                setDownloadProgress((p) => (p?.requestId === requestId ? null : p));
                return;
            }
            try {
                const res = await axios.get(`mail-logger/fleetstockdownloads/progress/${requestId}`);
                const d = res.data?.data;
                setDownloadProgress((prev) =>
                    prev?.requestId === requestId
                        ? { ...prev, ...d, progressPercent: d?.progressPercent ?? 0, progressMessage: d?.progressMessage ?? prev?.progressMessage }
                        : prev
                );
                if (d?.emailSent === true || d?.progressPercent >= 100) {
                    if (pollRef.current) clearInterval(pollRef.current);
                    toast.success("Report sent to your email.");
                    setTimeout(() => setDownloadProgress((p) => (p?.requestId === requestId ? null : p)), 2500);
                    return;
                }
                if (d?.error) {
                    if (pollRef.current) clearInterval(pollRef.current);
                    toast.error(d.error || "Download failed.");
                    setTimeout(() => setDownloadProgress((p) => (p?.requestId === requestId ? null : p)), 1500);
                }
            } catch {
                // keep polling on transient errors
            }
        };
        poll();
        pollRef.current = setInterval(poll, POLL_INTERVAL_MS);
    }, []);

    useEffect(() => {
        return () => {
            if (pollRef.current) clearInterval(pollRef.current);
        };
    }, []);

    const requestFleetStockDownload = useCallback(async (payload) => {
        setDownloadProgress({ requestId: null, progressPercent: 0, progressMessage: "Initiating..." });
        try {
            const res = await axios({
                method: "post",
                data: { ...payload, reportName: "Batch Wise Report" },
                url: "report/fleetStockDetails/download",
            });
            const requestId = res.data?.requestId;
            if (requestId) {
                setDownloadProgress({ requestId, progressPercent: 10, progressMessage: "Report queued..." });
                pollDownloadProgress(requestId, Date.now());
            } else {
                toast.success(res.data?.message ?? "Request submitted.");
                setDownloadProgress(null);
            }
        } catch (err) {
            setDownloadProgress(null);
            const msg = err?.response?.data?.error || err?.response?.data?.message || err?.message || "Something went wrong";
            toast.error(msg);
        }
    }, [pollDownloadProgress]);

    const getFleetOptions = useCallback(() => {
        if (allFleets && allFleets.data && allFleets.data.length) {
            return [
                {
                    label: "All",
                    value: "all",
                },
                {
                    label: "Clear",
                    value: "clear",
                },
                ...allFleets?.data?.map((fleet) => {
                    return {
                        value: fleet._id,
                        label: fleet.fleetName,
                    };
                }),
            ];
        }
    }, [allFleets]);

    const getHubOptions = useCallback(() => {
        // console.log({selectedHubs})
        if (allHubs && allHubs.data && allHubs.data.length) {
            return [
                {
                    label: "All",
                    value: "all",
                },
                ...(allHubs?.data?.length &&
                    allHubs?.data
                        // ?.filter((hub) => {
                        // const selectedFleetsVal = allFleets?.data?.filter(
                        //   (fleet) => selectedFleets === fleet._id
                        // );
                        // return selectedFleetsVal?.some(
                        //   (fleet) => fleet.fleetCode === hub.fleetCode
                        // );
                        // })
                        ?.map((hub) => {
                            return {
                                value: hub._id,
                                label: hub.hubName,
                            };
                        })),
            ];
        }
    }, [allHubs, selectedHubs]);


    const getConfigurationOptionss = useCallback(() => {
        if (allConfigurations && allConfigurations.data && allConfigurations.data.length) {
            return [
                {
                    label: "All",
                    value: "all",
                },
                ...allConfigurations?.data?.map((config) => {
                    return {
                        value: config._id,
                        label: config.make.makeName + "/" + config.model.name + "/" + config.name,
                    };
                }),
            ];
        }
    }, [allConfigurations]);

    const getProductOptions = useCallback(() => {
        if ((allProducts && allProducts.data && allProducts.data.length) || (allProductMasters && allProductMasters.data && allProductMasters.data.length)) {
            return [
                // {
                //     label: "All",
                //     value: "all",
                // },
                {
                    label: "Clear",
                    value: "clear",
                },
                ...contractType !== "NON CPKM" && allProducts ? allProducts?.data?.filter(product => product.tyrePattern)?.map((product) => {
                    return {
                        value: product._id,
                        label: product.tyrePattern,
                        meta: { ids: product.ids, sizes: product.sizes },
                        type: "CPKM"
                    };
                }) : [],
                ...contractType !== "CPKM" && allProductMasters ? allProductMasters?.data?.map((product) => {
                    return {
                        value: product._id,
                        label: product.productName,
                        meta: { sizes: [product.tyreSize?.name], ids: [product._id] },
                        type: "NON CPKM"
                    };
                }) : [],
            ];
        }
    }, [allProducts, allProductMasters]);

    const getSizeOptions = useCallback(() => {
        if ((allProducts && allProducts.data && allProducts.data.length) || (allProductMasters && allProductMasters.data && allProductMasters.data.length)) {
            //       let setObj = new Set(arr.map(JSON.stringify));
            // let output = Array.from(setObj).map(JSON.parse);
            let array = [
                {
                    label: "Clear",
                    value: "clear",
                },
                ...contractType === "" && !selectedProducts?.length ?
                    Array.from(new Set(getProductOptions()?.filter(item => item.value !== "all" && item.value !== "clear").flatMap(obj => (obj.meta?.sizes).map(size => ({ name: size, type: obj.type }))).map(JSON.stringify)))?.map(JSON.parse)
                        ?.map((size) => {
                            return {
                                value: size.name,
                                label: size.name + "/" + size.type,
                                type: size.type
                            };
                        })
                    :
                    [...contractType !== "NON CPKM" ?
                        selectedCPKMProducts?.length ? Array.from(new Set((selectedCPKMProducts).flatMap(obj => obj.meta.sizes)))
                            ?.map((size) => {
                                return {
                                    value: size,
                                    label: size,
                                    type: "CPKM"
                                };
                            }) :
                            Array.from(new Set(getProductOptions()?.filter(item => item.type === "CPKM").flatMap(obj => obj.meta.sizes)))
                                ?.map((size) => {
                                    return {
                                        value: size,
                                        label: size,
                                        type: "CPKM"
                                    };
                                })
                        : [],
                    ...contractType !== "CPKM" ?
                        selectedProducts?.length ? Array.from(new Set((selectedProducts)?.filter(item => item.type === "NON CPKM").flatMap(obj => obj.meta.sizes)))
                            ?.map((size) => {
                                return {
                                    value: size,
                                    label: size,
                                    type: "NON CPKM"
                                };
                            }) :
                            Array.from(new Set(getProductOptions()?.filter(item => item.type === "NON CPKM").flatMap(obj => obj.meta.sizes)))
                                ?.map((size) => {
                                    return {
                                        value: size,
                                        label: size,
                                        type: "NON CPKM"
                                    };
                                })
                        : [],]
            ];
            array.filter(item => item.value)?.sort((a, b) => {
                return a.value?.localeCompare(b?.value) ? -1 : 1
            });
            
            return array;

        } else return [];
    }, [allProducts, allProductMasters, selectedCPKMProducts]);

    const fleetTypes = [
        { label: "All", value: "" },
        { label: "Mobility", value: true },
        { label: "Fleet", value: false },
    ];

    const contractTypes = [
        { label: "All", value: "" },
        { label: "CPKM", value: "CPKM" },
        { label: "Service Contract", value: "NON CPKM" },
    ];

    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        console.log("selectedDate", e.target.value)

        setDateFrom(selectedDate);

        const oneYearAheadDate = new Date(selectedDate);
        oneYearAheadDate.setFullYear(oneYearAheadDate.getFullYear() + 1);
        oneYearAheadDate.setDate(oneYearAheadDate.getDate() - 1);

        const currentDate = new Date();

        const finalDate = oneYearAheadDate > currentDate ? currentDate : oneYearAheadDate;
        // setDateTo(getFormattedDate(finalDate));
    };


    const getHeaders = () => {
        return (
            <>
                <TH className="whitespace-nowrap" scope="col">S.N.</TH>
                <TH className="whitespace-nowrap" scope="col">Batch</TH>
                <TH className="whitespace-nowrap" scope="col">Brand</TH>
                <TH className="whitespace-nowrap" scope="col">Tyre Supplied</TH>
                <TH className="whitespace-nowrap" scope="col">ITM Scrap</TH>
                <TH className="whitespace-nowrap" scope="col">Avg ITM Scrap</TH>
                <TH className="whitespace-nowrap" scope="col">ITM</TH>
                <TH className="whitespace-nowrap" scope="col">Avg ITM</TH>
                <TH className="whitespace-nowrap" scope="col">RTD Scrap</TH>
                <TH className="whitespace-nowrap" scope="col">Avg RTD Scrap</TH>
                <TH className="whitespace-nowrap" scope="col">RTD1</TH>
                <TH className="whitespace-nowrap" scope="col">Avg RTD1</TH>
                <TH className="whitespace-nowrap" scope="col">RTD2</TH>
                <TH className="whitespace-nowrap" scope="col">Avg RTD2</TH>
                <TH className="whitespace-nowrap" scope="col">RTD3</TH>
                <TH className="whitespace-nowrap" scope="col">Avg RTD3</TH> 
                <TH className="whitespace-nowrap" scope="col">ITM proj. 85%</TH>
                <TH className="whitespace-nowrap" scope="col">ITM Avg proj. 85%</TH>
                <TH className="whitespace-nowrap" scope="col">RTD proj. 85%</TH>
                <TH className="whitespace-nowrap" scope="col">RTD Avg proj. 85%</TH>
            </>
        );
    };

    

    return (
        <div>

            <div className="w-full px-8 grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-auto  justify-center items-center gap-x-4 gap-y-0 mb-4 ">
              
            <label className="w-full py-3">
                    Select Fleets
                    <ReactSelect

                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: "transparent",
                                minWidth: "100%",
                                "&:hover": {
                                    borderColor: "rgb(34 197 94)",
                                },
                            }),
                        }}
                        className="shadow-md rounded-md py-1 mb-2"
                        options={getFleetOptions()}
                        value={
                            selectedFleets &&
                            selectedFleets?.map((fleet) => {
                                return {
                                    value: fleet,
                                    label: getFleetOptions()?.find((item) => item?.value === fleet)
                                        ?.label,
                                };
                            })
                        }
                        onChange={(value) => {
                            let allValues = value?.map((item) => item.value);
                            if (allValues?.includes("clear")) {
                                console.log(allValues)
                                setSelectedFleets([]);
                                setSelectedHubs([]);
                                return;
                            }
                            if (!selectedFleets?.includes("all") && allValues.includes("all")) {
                                setSelectedFleets(["all"]);
                                return;
                            }

                            if (selectedFleets.includes("all")) {
                                console.log("first");
                                console.log(getFleetOptions())
                                value = value.filter(item => item.value !== "all")
                            }
                            

                    
                            setSelectedFleets(value.map((fleet) => fleet.value));
                        }
                        }
                        name="fleets"
                        isMulti={true}
                    // isMulti={selectedFleets?.includes("all") ? false : true}
                    // isDisabled={selectedFleets?.includes("all") ? true : false}
                    />
                </label>
               

                <label className="w-full py-0 col-span-2  md:col-span-1">
                    Contract Type
                    <ReactSelect
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: "transparent",
                                minWidth: "100%",
                                "&:hover": {
                                    borderColor: "rgb(34 197 94)",
                                },
                            }),
                        }}
                        className="shadow-md rounded-md py-1 mb-2"
                        options={contractTypes}
                        value={contractTypes.find((fleetType) => {
                            return fleetType.value === contractType;
                        })}
                        onChange={(value) => {
                            setContractType(value.value);
                            if (value.value == "NON CPKM") {
                                setSelectedCPKMProducts([]);
                                setSelectedProducts(
                                    selectedProducts?.filter((item) => item.type !== "CPKM")
                                );
                            }
                            if (value.value == "CPKM") {
                                setSelectedProducts([]);
                                setSelectedCPKMProducts(
                                    selectedProducts?.filter((item) => item.type === "CPKM")
                                );
                            }
                        }}
                        name="contractType"
                        isMulti={false}
                    />
                </label>

                <label className="w-full py-0 col-span-2  md:col-span-1">
                    Select Brands
                    <ReactSelect
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: "transparent",
                                minWidth: "100%",
                                "&:hover": {
                                    borderColor: "rgb(34 197 94)",
                                },
                            }),
                        }}
                        className="shadow-md rounded-md py-1 mb-2"
                        // options={(()=>{
                        //   console.log(getProductOptions());
                        // return getProductOptions()})()}
                        options={getProductOptions()}
                        placeholder="All"
                        value={
                            selectedProducts &&
                            selectedProducts?.map((product) => {
                                console.log("product in value" , product)
                                return {
                                    value: product.value,
                                    label: getProductOptions()
                                        // ?.filter((item) => item.value !== "all" || selectedProducts.length === 1)
                                        ?.find((item) => item.value === product.value)?.label,
                                    meta: getProductOptions()
                                        // ?.filter((item) => item.value !== "all" && item.value !== "clear")
                                        ?.find((item) => item.value === product.value)?.meta,
                                    type: getProductOptions()
                                        // ?.filter((item) => item.value !== "all" && item.value !== "clear")
                                        ?.find((item) => item.value === product.value)?.type,
                                };
                            })
                        }
                        onChange={(value) => {
                            const allValues = value?.map((item) => item.value);
                            console.log("allValues" , allValues)
                            // console.log({selectedProducts, selectedCPKMProducts})

                            // Array.from(new Set(data.flatMap(obj => obj.subs)))

                            if (allValues?.includes("clear")) {
                                setSelectedProducts([]);
                                setSelectedCPKMProducts([]);
                                return;
                            }


                            if (allValues.includes("all")) {
                                value = value.filter(item => item.value !== "all")
                                // setSelectedProducts(
                                //     getProductOptions()?.filter((item) => item.value !== "all")
                                // );
                                // setSelectedCPKMProducts(
                                //     getProductOptions()
                                //         ?.filter((item) => item.value !== "all")
                                //         ?.filter((item) => item.type === "CPKM")
                                // );
                                setSelectedProducts(["all"])
                                return;
                            }else{

                                setSelectedProducts(value);
                                setSelectedCPKMProducts(
                                    value
                                    .filter((product) => product.type === "CPKM")
                                );

                            }


                        }}

                        name="products"
                        isMulti={true}
                    />
                </label>

              

<label className="w-full py-0 col-span-2 md:col-span-1">
            Select Sizes
            <ReactSelect
                styles={{
                    control: (base) => ({
                        ...base,
                        borderColor: "transparent",
                        minWidth: "100%",
                        "&:hover": {
                            borderColor: "rgb(34 197 94)",
                        },
                    }),
                }}
                className="shadow-md rounded-md py-1 mb-2"
                options={getSizeOptions()}
                placeholder="All"
                value={
                    selectedSizes.map((size) => ({
                        value: size,
                        label: size,
                    }))
                }
                onChange={(value) => {
                    const allValues = value?.map((item) => item.value);

                    if (allValues?.includes("clear")) {
                        setSelectedSizes([]);
                        setSelectedCPKMSizes([]);
                        return;
                    }

                    if (allValues.includes("all")) {
                        const allSizeOptions = getSizeOptions().filter((item) => item.value !== "all");

                        setSelectedSizes(allSizeOptions.map((item) => item.value));
                        setSelectedCPKMSizes(allSizeOptions.map((item) => item.value)); // Set all tire types here
                    } else {
                        console.log(value);

                        setSelectedSizes(value.map((make) => make.value));
                        setSelectedCPKMSizes(value.map((product) => product.value)); // Set all selected values here
                    }
                }}
                name="tyreSize"
                isMulti={true}
            />
        </label>

                
            </div>
            <div className="w-full px-8 flex items-center gap-4">
                <label>
                    Start Date{" "}
                    <Input
                        type="date"
                        max={getFormattedDate()}
                        name="dateFrom"
                        value={dateFrom}
                        onChange={handleFromDateChange}
                    />
                </label>
                <label>
                    End Date{" "}
                    <Input
                        type="date"
                        min={dateFrom}
                        name="dateTo"
                        value={dateTo}
                        onChange={(e) => setDateTo(e.target.value)}
                    />
                </label>
                <button
                    type="button"
                    disabled={
                        loadingFleets ||
                        !selectedFleets.length ||
                        !getFleetOptions()?.length ||
                        !getHubOptions()?.length || !dateFrom
                    }
                    className={`items-end mt-5 align-end bg-green-500 p-2 text-lg text-white rounded-lg  w-24 ${(loadingFleets ||
                        !selectedFleets.length ||
                        !getFleetOptions()?.length ||
                        !getHubOptions()?.length || !dateFrom ) &&
                        "bg-gray-400"
                        } col-span-1`}
                    bgPrimary
                    onClick={() => {
                        setFetch((st) => st + 1);
                        getData()
                    }}
                >
                    Search
                </button>
                {downloading ? 'Downloading...' : selectedHubs.length !==0 &&  <BiCloudDownload
                 className="w-10 h-10 mt-5 text-green-500 hover:scale-105 cursor-pointer "
                 onClick={() => {
                 getDownloadData()
          }}
        />}
            </div>

            {downloadProgress?.requestId && (
                <div className="mt-3 w-full max-w-md rounded-lg border border-gray-200 bg-white p-3 shadow-sm">
                    <p className="mb-1 text-sm font-medium text-gray-700">Batch Wise Report – generating report</p>
                    <div className="h-2 w-full overflow-hidden rounded-full bg-gray-200">
                        <div
                            className="h-full rounded-full bg-green-500 transition-all duration-300"
                            style={{ width: `${Math.min(100, Math.max(0, downloadProgress.progressPercent ?? 0))}%` }}
                        />
                    </div>
                    <p className="mt-1 text-xs text-gray-500">{downloadProgress.progressMessage ?? "Please wait..."}</p>
                </div>
            )}

            {isLoading ? (
                <Spinner />
            ) : (
                <div className="flex flex-col m-2 lg:m-10">
                    <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                            <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-50">
                                        <tr>
                                            {getHeaders()}
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        
                                            
                                        {
                                            data && data?.map((item , idx)=>{
                                                return <ViewBatchList idx={idx + 1} batch={item?.batch} data={item?.data} item={item} dateFrom={dateFrom} dateTo={dateTo} selectedFleets={selectedFleets} contractType={contractType} selectedCPKMProducts={selectedCPKMProducts} selectedProducts={selectedProducts} allFleets={allFleets} selectedCPKMSizes={selectedCPKMSizes} onRequestFleetStockDownload={requestFleetStockDownload} downloadProgress={downloadProgress}/>
                                            })
                                        }
                                            
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    )
}

export default BatchWiseReport

//for the summary of every year and batch
const ViewBatchList = ({ idx , batch , data , item , dateFrom, dateTo, selectedFleets, contractType, selectedCPKMProducts , selectedCPKMSizes, selectedProducts , allFleets = {}, onRequestFleetStockDownload, downloadProgress }) => {

    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [downloadTitle, setDownloadTitle] = useState('Total Batch Wise Report Download')

    const downloadDiv = (data) => {

        return <div class="flex gap-2 items-center justify-center">
            <span
                className="text-gray-600  cursor-pointer"
                onClick={() => console.log("data?.count" , data?.count)}
                // onClick={() => {
                //     console.log("data?.count" , data?.count)
                //     // modalHandler({ data: data });
                //     // setFleet(data?.fleet);
                // }}
            >
                {data?.count}
            </span>
        </div>
    }

    const allTyresSupplied = extractFieldValues(data, 'tyreSupplied');
    const allCountITMScrap = extractFieldValues(data, 'countITMScrap')
    const allCountITM = extractFieldValues(data, 'countITM')
    const allCountRTDScrap = extractFieldValues(data, 'countRTDScrap')
    const allCountRTD1 = extractFieldValues(data, 'countRTD1')
    const allCountRTD2 = extractFieldValues(data, 'countRTD2')
    const allCountRTD3 = extractFieldValues(data, 'countRTD3')
    const allCountITM85Projection = extractFieldValues(data, 'countITM85Projection')
    const allCountRTD85Projection = extractFieldValues(data, 'countRTD85Projection')

    return (
        <Fragment>
            {showModal && (
                <Modal
                    handleClick={() => setShowModal(false)}
                    title={"Batch Wise Report Details"}
                    className="max-w-2xl"
                >
                    {/* <h1>This is the modal</h1> */}
                    <h1 className="w-full flex justify-end text-end px-2 my-1">
                       
                           <Button
                            onClick={() => {
                                if (!onRequestFleetStockDownload) return;
                                const payload = {
                                    ...(selectedFleets !== "all" ? { fleets: Array.isArray(selectedFleets) ? selectedFleets.join(",") : selectedFleets } : { fleets: allFleets?.data?.map(d => d._id).join(",") }),
                                    ...(contractType && { contractType }),
                                    ...(dateFrom && { startFitmentDate: dateFrom }),
                                    ...(dateTo && { endFitmentDate: dateTo }),
                                    ...(selectedCPKMProducts?.length && { cpkmproducts: selectedCPKMProducts.flatMap((make) => make.meta.ids).join(",") }),
                                    ...(selectedProducts?.length && { products: selectedProducts.flatMap(p => p.meta.ids).join(",") }),
                                };
                                onRequestFleetStockDownload(payload);
                            }}
                            disabled={!!downloadProgress?.requestId}
                            className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
                        >
                            Download
                        </Button>
                    </h1>
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <TH scope="col">S.N.</TH>
                                <TH scope="col">Fitted Date</TH>
                                <TH scope="col">Stencil Number</TH>
                                <TH scope="col">Size</TH>
                                <TH scope="col">Brand</TH>
                                <TH scope="col">Tyre Type</TH>
                                <TH scope="col">Tyre Location</TH>
                                <TH scope="col">RUN KM </TH>
                                <TH scope="col">Projection KM </TH>
                               
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {modalData &&
                                modalData?.length > 0 &&
                                modalData?.map((scrap, index) => (
                                        <tr>
                                        <TD>{index + 1}</TD>
                                        <TD>{convertToIndianTimezoneAndGetDate(scrap?.fittedDate)}</TD>
                                        <TD>{scrap?.stencilNumber}</TD>
                                        <TD>{scrap?.size}</TD>
                                        <TD>{scrap?.brand ?? scrap?.materialNo}</TD>
                                        <TD>{scrap?.tyreType}</TD>
                                        <TD>{getLocation(scrap?.status)}</TD>
                                        <TD>{scrap?.runKm}</TD>
                                        <TD>{scrap?.projectionKm }</TD>
                                      
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </Modal>
            )}
            <tr className="bg-green-100 text-white">
                <TD className="font-semibold text-gray-600">{idx}</TD>
                <TD className="font-semibold text-gray-600">{batch}</TD>
                <TD className="font-semibold text-gray-600">-</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.totalTyreSupplied ? item?.totalTyreSupplied : 0, data: allTyresSupplied })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.totalCountITMScrap ? item?.totalCountITMScrap : 0, data: allCountITMScrap })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.avgITMScrap ? item?.avgITMScrap : 0, data: allCountITMScrap })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.totalCountITM ? item?.totalCountITM : 0, data: allCountITM })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.avgITM ?  item?.avgITM : 0, data: allCountITM })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.totalCountRTDScrap ? item?.totalCountRTDScrap : 0, data: allCountRTDScrap })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.avgRTDScrap ? item?.avgRTDScrap : 0, data: allCountRTDScrap })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.totalCountRTD1 ? item?.totalCountRTD1 : 0, data: allCountRTD1 })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.avgRTD1 ? item?.avgRTD1 : 0, data: allCountRTD1 })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.totalCountRTD2 ? item?.totalCountRTD2 : 0, data: allCountRTD2 })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.avgRTD2 ? item?.avgRTD2 : 0, data: allCountRTD2 })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.totalCountRTD3 ? item?.totalCountRTD3 : 0, data: allCountRTD3 })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.avgRTD3 ? item?.avgRTD3 : 0, data: allCountRTD3 })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.totalCountITM85Projection ? item?.totalCountITM85Projection : 0, data: allCountITM85Projection })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.avgITM85Projection ? item?.avgITM85Projection : 0, data: allCountITM85Projection })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.totalCountRTD85Projection ? item?.totalCountRTD85Projection : 0, data: allCountRTD85Projection })}</TD>
                <TD className="font-semibold">{downloadDiv({ count: item?.avgRTD85Projection ? item?.avgRTD85Projection : 0, data: allCountRTD85Projection })}</TD>
            </tr>
            {
                data?.map((item, idx) => {
                    // const indexChar = String.fromCharCode(97 + idx);
                    return (
                        <ViewList indexChar={"."} batch={batch} data={item}
                            status={item.status}
                            selectedCPKMSizes={selectedCPKMSizes}
                            dateFrom={dateFrom} dateTo={dateTo} selectedFleets={selectedFleets}
                            contractType={contractType} selectedCPKMProducts={selectedCPKMProducts}
                            selectedProducts={selectedProducts} allFleets={allFleets}
                            onRequestFleetStockDownload={onRequestFleetStockDownload} downloadProgress={downloadProgress} />
                    )
                })
            }

        </Fragment>
        

    )
}

function extractFieldValues(data, fieldName) {
    return data?.reduce((accumulator, currentValue) => {
        return accumulator.concat(currentValue[fieldName] || []);
    }, []);
}

const ViewList = ({ indexChar , data, batch, dateFrom, dateTo, selectedFleets, contractType, selectedCPKMProducts , selectedProducts, selectedCPKMSizes, onRequestFleetStockDownload, downloadProgress }) => {
    const [showModal, setShowModal] = useState(false);
    const [modalData, setModalData] = useState([]);
    const [downloadTitle, setDownloadTitle] = useState('Batch Wise Report Download')

    const { data: allFleets, isLoading: loadingFleets, refetch } = useQuery(
        [
            "customer-fleet",
        ], () =>
        getAllData("/customer-fleet", {
            limit: 3000,
        })
    );

    const getFleetOptions = useCallback(() => {
        if (allFleets && allFleets.data && allFleets.data.length) {
            return [
                {
                    label: "All",
                    value: "all",
                },
                {
                    label: "Clear",
                    value: "clear",
                },
                ...allFleets?.data?.map((fleet) => {
                    return {
                        value: fleet._id,
                        label: fleet.fleetName,
                    };
                }),
            ];
        }
    }, [allFleets]);


    const downloadDiv = (brand, tyreType, status, moreThanPercentageWear, data) => {
        // console.log(tyreType, status, moreThanPercentageWear)
        return <div class="flex gap-2 items-center justify-center">
            <span
                className="hover:text-green-500 cursor-pointer"
                onClick={() => {
                    if(data?.count !== 0){
                        console.log(data, brand)
                        modalHandler({ brand, tyreType, status, moreThanPercentageWear, data: data });
                    }
                    // setFleet(data?.fleet);
                }}
            >
                {data?.count}
            </span>
        </div>
    }

    const modalHandler = useCallback(
        (data) => {
            console.log(data.data, data.brand, data.status)
            if (data) {
                setModalData({ ...data?.data, brand: data?.brand, moreThanPercentageWear: data?.moreThanPercentageWear, status: data?.status, tyreType: data?.tyreType });
                setShowModal(true);
                // setDownloadTitle(data?.data?.title)
            } else {
                setShowModal(false);
                setModalData([]);
            }
        },
        [showModal, modalData]
    );


    const renderRowData = () => {
        // Handle brand - if it's an array, take first element
        const brandValue = Array.isArray(data?.brand) ? data?.brand[0] : data?.brand;
        // Use materialNo as fallback if brand is not available
        const displayBrand = brandValue || data?.materialNo || '---';
        
        return (
            <tr>
                <TD className="font-semibold">
                    <div className="h-full flex justify-center w-full">
                    <div className="h-1 w-1 bg-darkGrey rounded-full"></div>
                    </div>
                </TD>
                <TD>{batch}</TD>
                <TD>{displayBrand}</TD>
                <TD>{downloadDiv(displayBrand, "", "", null, { count: data?.tyreSupplied.length, data: data?.tyreSupplied })}</TD>
                <TD>{downloadDiv(displayBrand,"ITM", ["SCRAP","MISSING"], null, { count: data?.countITMScrap.length, data: data?.countITMScrap })}</TD>
                <TD>{downloadDiv(displayBrand,"ITM", ["SCRAP","MISSING"], null, { count: data?.avgITMScrap ? Math.round(data?.avgITMScrap) : 0, data: data?.countITMScrap})}</TD>
                <TD>{downloadDiv(displayBrand, "ITM", ["CASING"], null, { count: data?.countITM.length, data: data?.countITM })}</TD>
                <TD>{downloadDiv(displayBrand,"ITM", ["CASING"], null, { count: data?.avgITM ? Math.round(data?.avgITM) : 0, data: data?.countITM })}</TD>
                <TD>{downloadDiv(displayBrand, "RTD", ["SCRAP","MISSING"], null, { count: data?.countRTDScrap.length, data: data?.countRTDScrap })}</TD>
                <TD>{downloadDiv(displayBrand, "RTD", ["SCRAP","MISSING"], null, { count: data?.avgRTDScrap ? Math.round(data?.avgRTDScrap) : 0, data: data?.countRTDScrap })}</TD>
                <TD>{downloadDiv(displayBrand,"RTD1", ["CASING"], null, { count: data?.countRTD1.length, data: data?.countRTD1 })}</TD>
                <TD>{downloadDiv(displayBrand,"RTD1", ["CASING"],null, { count: data?.avgRTD1 ? Math.round(data?.avgRTD1) : 0, data: data?.countRTD1 })}</TD>
                <TD>{downloadDiv(displayBrand,"RTD2", ["CASING"],null, { count: data?.countRTD2.length, data: data?.countRTD2 })}</TD>
                <TD>{downloadDiv(displayBrand,"RTD2", ["CASING"],null, { count: data?.avgRTD2 ? data?.avgRTD2 : 0, data: data?.countRTD2 })}</TD>
                <TD>{downloadDiv(displayBrand,"RTD3", ["CASING"],null, { count: data?.countRTD3.length, data: data?.countRTD3 })}</TD>
                <TD>{downloadDiv(displayBrand,"RTD3", ["CASING"],null, { count: data?.avgRTD3 ? data?.avgRTD3 : 0, data: data?.countRTD3 })}</TD>
                <TD>{downloadDiv(displayBrand,"ITM", ["FITTED","REUSE","REPAIR"],0.25, { count: data?.countITM85Projection.length, data: data?.countITM85Projection })}</TD>
                <TD>{downloadDiv(displayBrand,"ITM", ["FITTED","REUSE","REPAIR"],0.25, { count: data?.avgITM85Projection ? Math.round(data?.avgITM85Projection) : 0, data: data?.countITM85Projection })}</TD>
                <TD>{downloadDiv(displayBrand,"RTD1", ["FITTED","REUSE","REPAIR"],0.25, { count: data?.countRTD85Projection.length, data: data?.countRTD85Projection })}</TD>
                <TD>{downloadDiv(displayBrand,"RTD1", ["FITTED","REUSE","REPAIR"],0.25, { count: data?.avgRTD85Projection ? Math.round(data?.avgRTD85Projection) : 0, data: data?.countRTD85Projection })}</TD>
            </tr>
        );
    };


    // console.log("Selected Fleets", selectedFleets)
    return (
        <Fragment>
            {showModal && (
                <Modal
                    handleClick={() => setShowModal(false)}
                    title={"Batch Wise Report Details"}
                    className="max-w-2xl"
                >
                    {/* <h1>This is the modal</h1> */}
                    <h1 className="w-full flex justify-end text-end px-2 my-1">
                        
                        <Button
                            onClick={() => {
                                if (!onRequestFleetStockDownload) return;
                                const payload = {
                                    ...(modalData?.brand ? { brand: modalData?.brand } : {}),
                                    ...(modalData?.status ? { status: modalData?.status } : {}),
                                    ...(modalData?.tyreType ? { tyreType: modalData?.tyreType } : {}),
                                    batch: String(batch),
                                    ...(selectedFleets !== "all" ? { fleets: selectedFleets?.join(",") } : { fleets: allFleets?.data?.map(d => d._id).join(",") }),
                                    ...(contractType && { contractType }),
                                    ...(dateFrom && { startFitmentDate: dateFrom }),
                                    ...(dateTo && { endFitmentDate: dateTo }),
                                    ...(selectedCPKMProducts?.length && { cpkmproducts: selectedCPKMProducts.flatMap((make) => make.meta.ids).join(",") }),
                                    ...(selectedProducts?.length && { products: selectedProducts.flatMap(p => p.meta.ids).join(",") }),
                                    ...(selectedCPKMSizes?.length && { tyreSize: selectedCPKMSizes.map((s) => s).join(",") }),
                                };
                                onRequestFleetStockDownload(payload);
                            }}
                            disabled={!!downloadProgress?.requestId}
                            className=" text-blue-500 hover:scale-105 cursor-pointer text-right"
                        >
                            Download
                        </Button>

                        
                    </h1>
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                <TH scope="col">S.N.</TH>
                                <TH scope="col">Fitted Date</TH>
                                <TH scope="col">Stencil Number</TH>
                                <TH scope="col">Size</TH>
                                <TH scope="col">Brand</TH>
                                <TH scope="col">Tyre Type</TH>
                                <TH scope="col">Tyre Location</TH>
                                <TH scope="col">RUN KM </TH>
                                <TH scope="col">Projection KM </TH>
                               
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {modalData &&
                                modalData?.data?.length > 0 &&
                                modalData?.data?.map((scrap, index) => {  
                                 return <tr>
                                        <TD>{index + 1}</TD>
                                        <TD>{convertToIndianTimezoneAndGetDate(scrap?.fittedDate)}</TD>
                                        <TD>{scrap?.stencilNumber}</TD>
                                        <TD>{scrap?.size}</TD>
                                        <TD>{scrap?.brand || scrap?.materialNo || '---'}</TD>
                                        <TD>{scrap?.tyreType ? scrap?.tyreType : "ITM" }</TD>
                                        <TD>{getLocation(scrap?.status)}</TD>
                                        <TD>{scrap?.runKm}</TD>
                                        <TD>{scrap?.projectionKm}</TD>
                                    </tr>}
                                )}
                        </tbody>
                    </table>
                </Modal>
            )}
            {renderRowData()}
        </Fragment>
    )
}
